import { NewTabLinkIcon } from "../icons";

const extractTitleAndLink = (item: string) => {
  const title = item.substring(item.indexOf("[") + 1, item.indexOf("]"));
  const link = item.substring(item.indexOf("(") + 1, item.indexOf(")"));
  return { title, link };
};

const checkAndFindLinks = (item: string) => {
  const match = item.match(/\[[^\]]+\]\([^)]+\)/);

  if (match) {
    return match[0];
  } else {
    return "";
  }
};

const removeSpecialChars = (item: string) => {
  const charToRemove = ["-", "_", "*"];
  for (const char of charToRemove) {
    item = item.replace(char, "");
  }

  return item;
};

const beautifyDetails = (details: string[]) => {
  return details.map((item) => {
    if (item.includes("[") && item.includes("](")) {
      const detailsMeta = checkAndFindLinks(item);
      const { title, link } = extractTitleAndLink(detailsMeta);

      const [beforeLink, afterLink] = item.split(detailsMeta);

      return (
        <>
          {beforeLink}
          <a href={link} target="_blank" rel="noreferrer">
            {title}
            <NewTabLinkIcon />
          </a>
          {afterLink}
        </>
      );
    } else {
      return item;
    }
  });
};

const beautifyMessage = (message: string) => {
  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  const boldRegex = /\*\*(.*?)\*\*/g;

  const lines = message.split('\n');
  const parts: JSX.Element[] = [];
  let headingCounter = 1;

  lines.forEach((line, lineIndex) => {
    const isHeading = line.trim().startsWith('###');

    let contentLine = line;
    if (isHeading) {
      contentLine = line.replace(/^###\s*/, ''); // Remove ###
    }

    // Combine bold and link regex
    const combinedRegex = new RegExp(`${linkRegex.source}|${boldRegex.source}`, 'g');
    const matches = Array.from(contentLine.matchAll(combinedRegex));
    const elements: JSX.Element[] = [];
    let currentIndex = 0;

    matches.forEach((match, matchIndex) => {
      const [fullMatch, title, link, boldText] = match;
      const matchStart = match.index!;

      if (matchStart > currentIndex) {
        elements.push(
          <span key={`text-${lineIndex}-${matchIndex}`}>
            {contentLine.substring(currentIndex, matchStart)}
          </span>
        );
      }

      if (title && link) {
        elements.push(
          <a
            href={link}
            target="_blank"
            rel="noreferrer"
            key={`link-${lineIndex}-${matchIndex}`}
          >
            {title}
            <NewTabLinkIcon />
          </a>
        );
      } else if (boldText) {
        elements.push(
          <strong key={`bold-${lineIndex}-${matchIndex}`}>{boldText}</strong>
        );
      }

      currentIndex = matchStart + fullMatch.length;
    });

    if (currentIndex < contentLine.length) {
      elements.push(
        <span key={`tail-${lineIndex}`}>{contentLine.substring(currentIndex)}</span>
      );
    }

    if (isHeading) {
      parts.push(
        <h3 key={`heading-${lineIndex}`}>
          <span>{`${headingCounter++}. `}</span>
          {elements}
        </h3>
      );
    } else {
      parts.push(<p key={`para-${lineIndex}`}>{elements}</p>);
    }
  });

  return <>{parts}</>;
};

export { beautifyDetails, extractTitleAndLink, beautifyMessage };
